import React from "react";
import { Typography, Row, Col, Card, Space, Divider } from "antd";
import { StyledList, StyledItem } from "./style";
import { detailedContent } from "./constants";

const { Text, Title } = Typography;

const DetailedHistory = () => {
  return (
    <>
      <Space direction="horizontal" style={{ width: "100%", justifyContent: "center" }}>
        <Title>Detaljert historie</Title>
      </Space>
      <Divider />

      {Object.entries(detailedContent).map(([year, types]) => (
        <Card key={year} title={year} style={{ marginBottom: "5px" }}>
          <Row gutter={[100, 20]}>
            <Col md={12} sm={24} xs={24}>
              <Title level={5}>Medlemmer</Title>
              <StyledList>
                {types.map(type => (
                  <React.Fragment key={type.member}>
                    {type.member ? (
                      <StyledItem>
                        {type.member}
                        {type.role ? <Text> ({type.role}) </Text> : null}
                      </StyledItem>
                    ) : null}
                  </React.Fragment>
                ))}
              </StyledList>
            </Col>
            <Col md={12} sm={24} xs={24}>
              <Title level={5}>Aktiviteter</Title>
              <StyledList>
                {types.map(type => (
                  <React.Fragment key={type.activity}>
                    {type.activity ? <StyledItem>{type.activity}</StyledItem> : null}
                  </React.Fragment>
                ))}
              </StyledList>
            </Col>
          </Row>
        </Card>
      ))}
    </>
  );
};

export default DetailedHistory;
